import { Button, Typography } from "@mui/material";
import styles from "./HeaderItem.module.scss";

interface IHeaderNavigation {
  children: any;
  onClickItem: any;
  showActiveIndicator?: boolean;
  className?: any;
  style?: any;
}
export const HeaderNavigateItem = (props: IHeaderNavigation) => {
  const { children, onClickItem, showActiveIndicator, style } = props;
  return (
    <div
      className={
        showActiveIndicator
          ? `${styles.item_container} ${styles.active_header_item}`
          : styles.item_container
      }
    >
      <Button
        aria-controls="simple-menu"
        className={styles.header_btn_txt}
        aria-haspopup="true"
        onClick={onClickItem}
        style={style}
      >
        {children}
      </Button>
    </div>
  );
};

export const MobileHeaderNavigateItem = (props: IHeaderNavigation) => {
  const { children, onClickItem, className } = props;
  return (
    <div style={{ textAlign: "left", paddingTop: "29px" }}>
      <Typography
        aria-controls="simple-menu"
        className={styles.mobile_header}
        aria-haspopup="true"
        onClick={onClickItem}
      >
        {children}
      </Typography>
    </div>
  );
};
